import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ShareDataService } from 'src/app/_services/ShareData.service';
import { AdminServiceService } from 'src/app/_services/AdminService.service';
import { AlertifyService } from 'src/app/_services/alertify.service';
import { ActionType } from 'src/app/_models/ActionType.enum';
import { DataSource } from 'src/app/_models/DataSource';


@Component({
  selector: 'app-emailTemplate',
  templateUrl: './emailTemplate.component.html',
  styleUrls: ['./emailTemplate.component.css']
})
export class EmailTemplateComponent implements OnInit  {

  CkeditorConfig = {
    versionCheck: false,
    allowedContent: true,
    height: 400
  }


  emailConfigSelected: any;
  currentApiKey: any;
  emailTemplateForm: FormGroup;
  isSaving= false;
  @ViewChild('closeTemplateModalBtn') closeBtn: ElementRef;
  @ViewChild( 'emailContent' ) editor;
  selectedData: any;
  currentTemplate: any;
  currentViewMode = 'edit';
  isSaved = true;

  constructor(private _shareData: ShareDataService, private _adminService: AdminServiceService, private _alertify: AlertifyService) { }

  ngOnInit() {

    
    this.initFormForNew();


    this._shareData.currentApiKey.subscribe(apiKey => {
      this.currentApiKey = apiKey;
    });

    this._shareData.currentDataSource.subscribe(data => {

      if (data)
      {
        if (data.action == ActionType.Added || data.action == ActionType.Updated)
          return;


        if (data.key == "emailtemplates") 
        {
          this.emailConfigSelected = data;
          return;
        }

        if (data.key == "emailtemplate")
        {
          this.selectedData = data;
          
          if (this.selectedData)
          {
            if (!this.selectedData.value) {
              this.initFormForNew();
            } else {
              this.initFormForUpdate(this.selectedData.value);
            }
            this.isSaved = true;
          }
        }
      }

    });

  }

   private initFormForNew() {
    // this.emailTemplateForm = new FormGroup({
    //   Title: new FormControl('', Validators.required),
    //   ShortDescription: new FormControl(''),
    //   Content: new FormControl('')
    // });  

    this.currentTemplate = {
      Title: "",
      Code: "",
      ShortDescription: "",
      Content: ""
    };

  }

  private initFormForUpdate(data) {
  
    //console.log('Init template for edit...', data);
    // this.emailTemplateForm = new FormGroup({
    //   Title: new FormControl(data.title, Validators.required),
    //   ShortDescription: new FormControl(data.shortDescription),
    //   Content: new FormControl(data.content)
    // });  
    this.currentTemplate = {
      Title: data.title,
      Code: data.code,
      ShortDescription: data.shortDescription,
      Content: data.content
    };


  }  

 
  onSaveTemplate() {

    if (this.editor.instance.mode == 'source') {
      this._alertify.warning("Switch editor to wysiwyg mode before save.");
      return;
    }

    this.isSaving = true;
    var templateData = this.currentTemplate; //this.emailTemplateForm.value;

    if (this.selectedData && this.selectedData.id && this.selectedData.id > 0) {
      templateData.Id = this.selectedData.value.id;
      this._adminService.updateEmailTemplate(this.currentApiKey, this.emailConfigSelected.value.id, templateData).subscribe(()=> {
        this._alertify.success("Email Template Updated Successfully");
        this.notifyAction(this.currentApiKey, ActionType.Updated,  "emailtemplate", templateData);
        this.closeBtn.nativeElement.click();
        this.isSaving = false;
        this.isSaved = true;
      }, error => {
        this._alertify.error(error);
        this.isSaving = false;
      });      
    } else {
      this._adminService.addNewEmailTemplate(this.currentApiKey, this.emailConfigSelected.value.id, templateData).subscribe(response => {
        templateData.id = response["id"];
        templateData.emailConfigId = this.emailConfigSelected.value.id;
        this._alertify.success("Email Template Added Successfully");
        this.notifyAction(this.currentApiKey, ActionType.Added, "emailtemplate", templateData);
        this.closeBtn.nativeElement.click();
        this.isSaving = false;
        this.isSaved = true;
      }, error => {
        this._alertify.error(error);
        this.isSaving = false;
      });
    }

  }

  private notifyAction(id: any, action: ActionType, key: string,  value: any) {
    this._shareData.notifyCurrentDataSource(new DataSource(id, action, key, value ));
  }

  onViewMode(mode) {

    if (mode == 'preview') {
      if (this.editor.instance.mode == 'source') {
        this._alertify.warning("Switch editor to wysiwyg mode before save.");
        return;
      }
  
    }

    this.currentViewMode = mode;
  }

  onTemplateChange() {
    this.isSaved = false;
  }
}
